module.exports = __webpack_public_path__ + "03_glasses_red.a077e034.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/03_glasses_red.png
// module id = aXsI
// module chunks = 0